import React from 'react';
import ContentLoader from 'react-content-loader';
import { Divider, ListItem, IconButton } from '@mui/material';
import { ZoomOutButton } from './ZoomOutButton';
import { Icon } from '../../lib/icons';

export const TrendsGraphContentLoader: React.FC<{ style?: any }> = (props) => (
    <ContentLoader
        speed={1.2}
        interval={0.1}
        width={399}
        height={222}
        viewBox="0 0 399 222"
        color="#f3f3f3"
        style={{ textDecorationSkipInk: 'inherit', ...props.style }}
    >
        <rect x="10" y="10" rx="3" ry="3" width="389" height="202" />
    </ContentLoader>
);

export const TrendsListItemContentLoader: React.FC<{ style?: any }> = (props): JSX.Element => (
    <ListItem dense style={{ background: 'transparent', padding: 0, textDecorationSkipInk: 'inherit', ...props.style }}>
        <ContentLoader
            speed={1.2}
            interval={0.1}
            width={360}
            height={71}
            viewBox="0 0 360 71"
            color="#f3f3f3"
            style={{ height: '71px' }}
        >
            <rect x="73" y="24" rx="3" ry="3" width="100" height="10" />
            <rect x="72" y="42" rx="3" ry="3" width="110" height="7" />
            <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
            <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />

            <rect x="28" y="27" rx="3" ry="3" width="18" height="18" />
        </ContentLoader>
    </ListItem>
);

export const TrendsListLoader = (): JSX.Element => (
    <>
        <TrendsListItemContentLoader />
        <Divider />
        <TrendsListItemContentLoader />
        <Divider />
        <TrendsListItemContentLoader />
        <Divider />
        <TrendsListItemContentLoader style={{ marginBottom: '0.5px' }} />
    </>
);

export const TrendsCardHeaderNotLoaded = (): JSX.Element => (
    <>
        <ZoomOutButton enabled={false} />
        <IconButton disabled size="large">
            <Icon.GetApp />
        </IconButton>
    </>
);
